import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {PreviewImageComponent} from '../preview-image/preview-image.component';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-why-gallery-component',
  templateUrl: './gallery-component.html',
  styleUrls: ['./gallery-component.scss']
})

export class GalleryComponent implements OnInit {
  // @Input() reportDetails: any;
  serverUrl = environment.server + '/public';
  reportImages = [];

  @Input() set reportDetails(value: any) {
    let tempObj = value;
    value.images.forEach((obj: any) => {
      if (obj !== '') {
        this.reportImages.push(obj);
      }
    });
  }

  constructor(public modalController: ModalController) {
  }

  ngOnInit(): void {
  }

  dismiss(): void {
    this.modalController.dismiss();
  }

  async previewImage(image) {
    const modal = await this.modalController.create({
      component: PreviewImageComponent,
      componentProps: {
        image: this.serverUrl + image
      },
      cssClass: 'custom-modal to-left',
      showBackdrop: true,
      backdropDismiss: true,
      swipeToClose: true
    });
    return await modal.present();
  }
}
